<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">{{ i18n("Menu.MenuName") }}</label>
              <treeselect
                :options="menuOptions"
                :disable-branch-nodes="true"
                placeholder="請選擇"
                v-model="search.menuGuid"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">{{
                i18n("Features.FeatureName")
              }}</label>
              <input
                type="text"
                id="search-name"
                class="form-control"
                placeholder="請輸入關鍵字"
                @keydown.stop.prevent.enter="getPermission()"
                v-model.trim="search.name"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="getPermission()"
            >
              {{ i18n("Buttons.Search") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              data-toggle="modal"
              data-target="#permissionModal"
              @click="permissionModal({ action: 'add' })"
            >
              {{ i18n("Buttons.AddFeature") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="edit" slot-scope="props">
          <button
            class="btn btn-info btn-sm"
            style="margin-right: 0.5rem"
            data-toggle="modal"
            data-target="#permissionModal"
            @click="permissionModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>

        <template slot="delete" slot-scope="props">
          <button
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delPermissionModal"
            @click="permission = props.row"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      class="modal fade"
      id="permissionModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="permission"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @submit.prevent="savePermission" @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">{{
                i18n("Features.AddFeature")
              }}</span>
              <span v-else>{{ i18n("Features.EditFeature") }}</span>
            </div>
            <div class="modal-body" style="height: 400px">
              <div class="form-group">
                <ValidationProvider
                  tag="section"
                  :name="i18n('Menu.MenuName')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="">
                    <span class="mark">*</span>
                    {{ i18n("Menu.MenuName") }}
                  </label>
                  <treeselect
                    :options="menuOptions"
                    :disable-branch-nodes="true"
                    placeholder="請選擇"
                    v-model="permission.MenuGuid"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  tag="section"
                  :name="i18n('Features.FeatureName')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="input-name">
                    <span class="mark">*</span>
                    {{ i18n("Features.FeatureName") }}
                    <span class="mark">(不可重複)</span>
                  </label>
                  <input
                    type="text"
                    id="input-name"
                    class="form-control"
                    maxlength="50"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="permission.Name"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  tag="section"
                  :name="i18n('Features.Type')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="input-type">
                    <span class="mark">*</span>
                    {{ i18n("Features.Type") }}
                  </label>
                  <input
                    type="text"
                    id="input-type"
                    class="form-control"
                    maxlength="50"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="permission.ClaimType"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger"
                    >{{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  tag="section"
                  :name="i18n('Features.DeclareValue')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="input-value">
                    <span class="mark">*</span>
                    {{ i18n("Features.DeclareValue") }}
                  </label>
                  <input
                    type="text"
                    id="input-value"
                    class="form-control"
                    maxlength="50"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="permission.ClaimValue"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger"
                    >{{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(savePermission)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      class="modal fade"
      id="delPermissionModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">{{ i18n("Features.DeleteFeature") }}</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ permission.Name }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delPermission"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "Features",

  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      search: {},

      // 判斷新增、編輯
      action: "add",

      // 功能
      permission: {},

      // 選單
      menuOptions: [],

      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: this.i18n("Menu.MenuName"),
          name: "MenuName",
        },
        {
          label: this.i18n("Features.FeatureName"),
          name: "Name",
        },
        {
          label: this.i18n("Features.Type"),
          name: "ClaimType",
        },
        {
          label: this.i18n("Features.DeclareValue"),
          name: "ClaimValue",
        },
        {
          label: "",
          name: "edit",
          slot_name: "edit",
        },
        {
          label: "",
          name: "delete",
          slot_name: "delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  computed: {
    ...mapGetters(["lang"]),
  },

  watch: {
    lang: function () {
      this.columns = [
        { label: this.i18n("Menu.MenuName"), name: "MenuName" },
        { label: this.i18n("Features.FeatureName"), name: "Name" },
        { label: this.i18n("Features.Type"), name: "ClaimType" },
        { label: this.i18n("Features.DeclareValue"), name: "ClaimValue" },
        { label: "", name: "edit", slot_name: "edit" },
        { label: "", name: "delete", slot_name: "delete" },
      ];
    },
  },

  methods: {
    // 分頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getPermission();
    },

    // 取得 功能
    getPermission() {
      this.updateLoading(true);
      if (!this.search.menuGuid) {
        this.search.menuGuid = null;
      }
      this.$api.permission
        .getPermissionPaging({
          name: this.search.name,
          menuGuid: this.search.menuGuid,
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Datas;
            this.totalData = response.data.Quantity;
          }
          this.updateLoading(false);
        });
    },

    // 新增、編輯 Modal
    permissionModal({ action, data }) {
      switch (action) {
        case "add":
          this.permission = {};
          this.action = "add";
          break;
        case "edit":
          this.permission = { ...data };
          this.action = "edit";
          break;
      }
      this.$refs.permission.reset();
    },

    // 新增、編輯 功能
    savePermission() {
      $("#permissionModal").modal("hide");
      let message;
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.permission
            .postPermission({
              ...this.permission,
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getPermission();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.permission
            .putPermission({
              ...this.permission,
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getPermission();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 刪除功能 API
    delPermission() {
      this.updateLoading(true);
      this.$api.permission
        .deletePermission(this.permission.Guid)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getPermission();
          }
          this.updateLoading(false);
        });
    },

    // 取得 選單
    getMenu() {
      this.updateLoading(true);
      this.$api.menu.getMenu().then((response) => {
        if (response.status === 200) {
          let menuList = [];
          response.data.forEach((item) => {
            let children = [];
            item.Children.forEach((element) => {
              let data = {
                id: element.Guid,
                label: element.MenuName,
              };
              children.push(data);
            });
            let parent = {
              id: item.Guid,
              label: item.MenuName,
              children: children,
            };
            menuList.push(parent);
          });
          this.menuOptions = menuList;
        }
        this.updateLoading(false);
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getMenu();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
